
import { defineComponent, reactive, onMounted, toRefs, computed } from 'vue'
import f10ApiHk from '@/api/f10ApiHk'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },

  setup(props) {
    const route = useRoute()
    const pageData = reactive({
      rawData: [] as any[],
      filterType: 'all', // 默认选中"过滤不分红"
      columns: [
        {
          title: '除净日',
          dataIndex: 'ExDateTime',
          key: 'ExDateTime',
          width: '120px',
          align: 'left'
        },

        {
          title: '分红方案',
          dataIndex: 'Ratio',
          key: 'Ratio',
          width: '200px',
          align: 'right'
        },


      ],
      spinning: true
    })

    // 格式化日期
    const formatDate = (timestamp: number | null) => {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    // 格式化报告期
    const formatReportPeriod = (record: any) => {
      const year = new Date(record.reportDate).getFullYear()
      return `${year}${record.reportPeriodType}`
    }

    // 处理API数据
    const processApiData = (data: any[]) => {
      return data.map(item => ({
        ...item,
        ExDateTime: item.ExDateTime,
        Ratio: item.ExDateTime,

      }))
    }

    // 过滤后的数据
    const filteredData = computed(() => {
      if (pageData.filterType === 'excludeNoDividend') {
        return pageData.rawData.filter(item => item.planExplain !== '不分红')
      }
      return pageData.rawData
    })



    onMounted(() => {
      console.log('res分红派息11111111111111')
      const data = {
        data: {
          // exchange: 'HKEX',
          // symbol: '00700',
          // exchange: route.query.market || 'HKEX',
          // exchange: route.query.exchange || route.query.market || 'HKEX',
          exchange: route.query.exchange || 'HKEX',
          symbol: route.query.code || '00700',
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
          type: '2'
        },
        headers: {

        }
      }

      f10ApiHk.getBriefStockBaseDetail(data).then((res: any) => {
        if (res.data && res.data) {
          console.log('res分红派息', res.data)
          pageData.rawData = processApiData(res.data)
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    })

    return {
      ...toRefs(pageData),
      filteredData,

    }
  }
})
